import styled from "styled-components"

// Mechanism to create a sticky footer

export const BodyAndFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 0 auto;
`

export const Body = styled.div`
  flex: 0 0 auto;
`

export const Footer = styled.div`
  flex: 0 0 auto;
`
